import web3Config from "../web3/web3Config.json";
// openAPI token is now issued by the server (POST /openapi-token) and cached until near expiry.
const BASE_URL = ((web3Config && web3Config.EMAIL_API) || "").replace(/\/+$/, "");
let cached = null;      // { token, expiresAtSec }
let inflight = null;
const nowSec = () => Math.floor(Date.now() / 1000);
async function requestToken() {
  const res = await fetch(`${BASE_URL}/openapi-token`, { method: "POST" });
  const data = await res.json().catch(() => ({}));
  const token = data?.token || "";
  // Never cache a token we did not actually get. A 5xx (or an HTML error page from the gateway) parses to
  // {} and yielded token === "", which was then cached for the full expiry window — so every later
  // /getEncryptValue in the session went out with no x-api-token and failed too, long after the server had
  // recovered. Throwing instead keeps the cache empty for the retry, and getEncryptedValue turns this into
  // the {__error:true} sentinel that aborts the send and names the recipient (see service/api-actions.js).
  if (!res.ok || !token) {
    throw new Error(`openapi-token request failed (${res.status})`);
  }
  const expiresIn = Number(data?.expiresIn) || 3600;
  cached = { token, expiresAtSec: nowSec() + expiresIn - 60 };
  return token;
}
export async function fetchOpenApiToken() {
  if (cached && cached.expiresAtSec > nowSec()) return cached.token;
  if (!inflight) inflight = requestToken().finally(() => { inflight = null; });
  return inflight;
}
// Back-compat alias — now async; all callers must await it.
export const generateOpenApiToken = fetchOpenApiToken;
